import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { TranslateModule } from "@ngx-translate/core";
import { MatToolbarModule } from "@angular/material/toolbar";
import { FuseSharedModule } from "@fuse/shared.module";
import { MatTabsModule } from "@angular/material/tabs";
import { MatListModule } from "@angular/material/list";
import { MatSelectModule } from "@angular/material/select";
import { MatTableModule } from "@angular/material/table";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSortModule } from "@angular/material/sort";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatCheckboxModule } from '@angular/material/checkbox';

import { ClientesComponent } from "./clientes/clientes.component";
import { TablaClientesComponent } from "./clientes/components/tabla-clientes/tabla-clientes.component";
import { DetalleClienteComponent } from "./detalle-cliente/detalle-cliente.component";
import { FichaClienteComponent } from "./detalle-cliente/components/ficha-cliente/ficha-cliente.component";
import { SucursalesComponent } from "./detalle-cliente/components/sucursales/sucursales.component";
import { EncargadoComponent } from "./detalle-cliente/components/encargado/encargado.component";
import { DialogClienteComponent } from "./clientes/components/dialog-cliente/dialog-cliente.component";
import { RepresentantesComponent } from "./detalle-cliente/components/representantes/representantes.component";
import { FichaRepresentanteComponent } from "./detalle-cliente/components/ficha-representante/ficha-representante.component";
import { DialogUsuarioComponent } from "./detalle-cliente/components/dialog-usuario/dialog-usuario.component";
import { AuthGuard } from "@auth0/auth0-angular";
import { RoleGuardService } from "../../shared/services/auth/role-guard.service";
import { DialogSucursalComponent } from './detalle-cliente/components/dialog-sucursal/dialog-sucursal.component';
import { TablaEncargadosComponent } from './detalle-cliente/components/encargado/compoments/tabla-encargados/tabla-encargados.component';
import { SearchboxComponent } from './clientes/components/searchbox/searchbox.component';
import { MatChipsModule } from "@angular/material/chips";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonToggleModule } from "@angular/material/button-toggle";

const routes = [
    {
        path: "clientes",
        component: ClientesComponent,
        canActivate: [AuthGuard, RoleGuardService],
        data: {
            allowedRoles: [1, 3],
        },
    },
    {
        path: "clientes/:idCliente",
        component: DetalleClienteComponent,
        canActivate: [AuthGuard, RoleGuardService],
        data: {
            allowedRoles: [1, 3],
        },
    },
    {
        path: "clientes/encargados/:idSucursal/:idCliente",
        component: EncargadoComponent,
        canActivate: [AuthGuard, RoleGuardService],
        data: {
            allowedRoles: [1, 3],
        },
    },
];

@NgModule({
    declarations: [
        ClientesComponent,
        TablaClientesComponent,
        DetalleClienteComponent,
        FichaClienteComponent,
        SucursalesComponent,
        DialogClienteComponent,
        RepresentantesComponent,
        FichaRepresentanteComponent,
        DialogUsuarioComponent,
        DialogSucursalComponent,
        EncargadoComponent,
        TablaEncargadosComponent,
        SearchboxComponent
    ],
    imports: [
        RouterModule.forChild(routes),
        CommonModule,
        MatDialogModule,
        MatIconModule,
        MatButtonModule,
        TranslateModule,
        MatToolbarModule,
        FuseSharedModule,
        MatTabsModule,
        MatListModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatFormFieldModule,
        MatInputModule,
        MatSlideToggleModule,
        BrowserAnimationsModule,
        MatSelectModule,
        MatCheckboxModule,
        MatChipsModule,
        MatAutocompleteModule,
        MatTableModule,
        MatListModule,
        MatButtonToggleModule,
        MatTabsModule
    ],
})
export class ClientesModule {}
